import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField, Typography } from "@mui/material";
import { mainColor } from "../../constants";
import AdminsTable from "../../components/Tables/AdminsTable";
import CustomButton from "../../components/CustomButton";
import { getCollectionByCondition } from "../../utils/firebase/dynamic";
import Spinner from "../../components/common/spinner";
import CloseIcon from '@mui/icons-material/Close';
import { Formik } from "formik";
import NewAdmin from "./NewAdmin";
const AdminsPage = () => {
  
  
  const [isloading, setLoading] = useState(false);
  
  const [toggle,setToggle]=React.useState("a");
  
  const handleToggle=()=>{
    setToggle(toggle=="a"?"n":"a")
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        // height:"100vh",
        width: "100%",

        marginTop: 30,
      }}
    >
      <div
        style={{
          width: "90%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "10px 0px",
        }}
      >
        <Typography variant="h6" style={{ fontSize: 30 }}>
          {toggle=="a"?"Admins":"New Admin"}
        </Typography>
        <CustomButton
          bg={mainColor}
          buttonText={toggle=="a"?"Add new admin":"Show admins"}
          onClick={handleToggle}
        />
      </div>
      {toggle=="a"&& (
        <AdminsTable
          change={isloading}
          firechange={setLoading}
          
        />
      )}
      {toggle=="n"&& (
        <NewAdmin
          firechange={setLoading}
          change={isloading}
        />
      )}
    </div>
  );
};

export default AdminsPage;


